<template>
  <v-dialog persistent scrollable v-model="dialog" width="400">
    <template v-slot:activator="{ on, attrs }">
      <div>
        <v-btn
          id="btnSimulator"
          rounded
          block
          elevation="0"
          color="#fb8200"
          dark
          v-bind="attrs"
          v-on="on"
          class="text-none"
          height="54"
          @click="dialog = true"
        >
          <span class="buttonText" v-html="messageButton"></span>
        </v-btn>
      </div>
    </template>

    <v-card style="background-color: #f4f4f4">
      <v-toolbar height="45" dark flat color="#494949">
        <v-toolbar-title style="font-weight: bold">
          <v-btn color="#f97900" small icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div v-if="!isError" style="padding: 20px !important">
          <div style="background-color: #f4f4f4" class="text-center">
            <div>
              <div class="text-center">
                <img
                  src="https://esfasil.com/wp-content/uploads/2022/09/fasil-logo.svg"
                  width="130"
                />
                <h3
                  style="
                    font-size: 16px;
                    color: #484848;
                    padding-top: 15px;
                    margin-bottom: 15px;
                  "
                >
                  <span v-html="message"></span>
                </h3>
              </div>
            </div>
            <v-stepper
              v-model="step"
              color="#f4f4f4"
              style="background-color: #f4f4f4; box-shadow: none"
            >
              <v-stepper-header
                style="background-color: #f4f4f4; box-shadow: none"
              >
                <v-stepper-step :complete="step > 1" step="1" color="#32c0c8">
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="step > 2" step="2" color="#ffb400">
                </v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :complete="step > 3" step="3" color="#02c7b1">
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items
                style="background-color: #f4f4f4; margin-top: 0px"
              >
                <ValidationObserver ref="form1">
                  <!-- Step 1 -->
                  <v-stepper-content step="1">
                    <div class="row">
                      <div class="col-12">
                        <p class="mb-2 question">
                          ¿Cuál es el valor de la casa?
                        </p>
                        <ValidationProvider
                          vid="propertyValue"
                          name="valor de tu casa"
                          :rules="{ required: true, rangePropertyValue: true }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            dense
                            class="mt-0 pt-0"
                            type="number"
                            hide-spin-buttons
                            v-model.trim="data.propertyValue"
                            :error-messages="errors"
                            :disabled="disableAllFields"
                            prefix="$"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <p class="mb-2 question">
                          ¿Qué porcentaje del valor de la casa, tienes para la
                          cuota inicial?
                        </p>
                        <div class="d-flex justify-content-center align-center">
                          <div class="d-flex">
                            <v-btn
                              class="mx-4"
                              outlined
                              fab
                              small
                              color="#f47600"
                              @click="lessPercentage"
                            >
                              <v-icon dark> mdi-minus</v-icon>
                            </v-btn>
                            <ValidationProvider
                              vid="percentageInitialFee"
                              name="porcentaje del valor de tu casa"
                              :rules="{
                                required: true,
                                rangePercentageInitialFee: true,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                style="width: 100px !important"
                                class="mt-0 pt-0"
                                dense
                                type="number"
                                :error-messages="errors"
                                hide-spin-buttons
                                :disabled="disableAllFields"
                                v-model.trim="data.percentageInitialFee"
                                suffix="%"
                              ></v-text-field>
                            </ValidationProvider>

                            <v-btn
                              class="mx-4"
                              outlined
                              fab
                              small
                              color="#f47600"
                              @click="morePercentage"
                            >
                              <v-icon dark> mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mb-1">
                        <v-btn
                          class="text-capitalize"
                          rounded
                          :color="color"
                          dark
                          @click="pageTwo"
                        >
                          Continuar
                        </v-btn>
                      </div>
                    </div>
                  </v-stepper-content>
                </ValidationObserver>
                <ValidationObserver ref="form2">
                  <!-- Step 2 -->
                  <v-stepper-content step="2">
                    <div class="row">
                      <div class="col-12 pb-0">
                        <ValidationProvider
                          vid="name"
                          name="nombre completo"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            dense
                            label="Nombre completo"
                            :error-messages="errors"
                            :disabled="disableAllFields"
                            v-model.trim="data.name"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 pb-0">
                        <ValidationProvider
                          vid="email"
                          name="email"
                          :rules="{ required: true, email: true }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            label="Email"
                            dense
                            :error-messages="errors"
                            :disabled="disableAllFields"
                            v-model.trim="data.email"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 pb-0">
                        <ValidationProvider
                          vid="phone"
                          name="celular"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            label="Celular"
                            dense
                            :error-messages="errors"
                            :disabled="disableAllFields"
                            v-model.trim="data.phone"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div
                          style="
                            background: #e5e5e5;
                            max-height: 130px;
                            border-radius: 10px;
                            padding: 10px;
                          "
                        >
                          <p class="text-justify">
                            Acepto Expresamente la Política de
                            <a
                              style="
                                color: #000;
                                text-decoration: underline;
                                font-weight: bolder;
                              "
                              @click.stop
                              href="https://esfasil.com/wp-content/uploads/2023/09/Terminos-y-Condiciones-y-Privacidad.pdf"
                              target="_blank"
                            >Tratamiento de Datos Personales.&#10;</a
                            >
                          </p>
                          <p class="text-justify">
                            Acepto Expresamente los
                            <a
                              style="
                                color: #000;
                                font-weight: bolder;
                                text-decoration: underline;
                              "
                              @click.stop
                              href="https://esfasil.com/wp-content/uploads/2023/09/Terminos-y-Condiciones-y-Privacidad.pdf"
                              target="_blank"
                            >Términos y Condiciones</a
                            >
                            de Uso de www.esfasil.com
                          </p>
                        </div>
                        <ValidationProvider
                          vid="termsConditions"
                          name="términos y condiciones"
                          :rules="{ required: { allowFalse: false } }"
                          v-slot="{ errors }"
                        >
                          <v-checkbox
                            class="p-0"
                            style="margin-top: 10px"
                            hide-details
                            :ripple="false"
                            :disabled="disableAllFields"
                            :error-messages="errors"
                            v-model="data.termsConditions"
                            label="Acepto Términos y Condicines"
                          >
                          </v-checkbox>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 mb-1">
                        <div class="d-flex justify-content-between">
                          <v-btn
                            class="text-capitalize"
                            rounded
                            color="#c9c9c9"
                            dark
                            @click="pageOne"
                          >
                            Atrás
                          </v-btn>

                          <v-btn
                            class="text-capitalize"
                            rounded
                            :color="color"
                            dark
                            @click="pageThree"
                          >
                            <v-progress-circular
                              size="20"
                              indeterminate
                              color="#ffffff"
                              v-if="loading"
                              style="margin: 0px; margin-right: 2px"
                            ></v-progress-circular>
                            Calcular mi cuota
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </v-stepper-content>
                </ValidationObserver>

                <!--Step 3-->
                <v-stepper-content step="3">
                  <div class="row">
                    <div class="col-12">
                      <p class="mb-2 question">
                        Valor de tu cuota con
                        <span style="font-weight: bold">FA$IL</span>
                      </p>
                      <p
                        style="
                          font-size: 25px;
                          border-bottom: 1px solid #000;
                          padding-bottom: 2px;
                        "
                      >
                        {{ response.customerFee | currency }}
                      </p>
                    </div>
                  </div>

                  <!--                  <div class="row">-->
                  <!--                    <div class="col-12">-->
                  <!--                      <p class="mb-1 mini-fee">-->
                  <!--                        Al final del pago de tu cuota inicial,-->
                  <!--                        <span class="font-weight-bold">FA$IL</span> te-->
                  <!--                        acompañará para conseguir un crédito hipotecario con un-->
                  <!--                        banco tradicional para terminar de financiar tu casa-->
                  <!--                      </p>-->
                  <!--                      <p class="mb-2 fee">-->
                  <!--                        <span class="font-weight-bold"-->
                  <!--                        >Valor total a financiar-->
                  <!--                        </span>-->
                  <!--                        con un crédito tradicional-->
                  <!--                      </p>-->
                  <!--                      <p-->
                  <!--                        style="-->
                  <!--                          font-size: 25px;-->
                  <!--                          border-bottom: 1px solid #000;-->
                  <!--                          padding-bottom: 2px;-->
                  <!--                        "-->
                  <!--                      >-->
                  <!--                        {{ response.traditionalMortgageCredit | currency }}-->
                  <!--                      </p>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <div class="row">
                    <div class="col-12">
                      <!--                      <p class="mb-2 fee">-->
                      <!--                        Valor de tu cuota con el-->
                      <!--                        <span class="font-weight-bold"-->
                      <!--                        >crédito hipotecario</span-->
                      <!--                        >-->
                      <!--                      </p>-->
                      <!--                      <p-->
                      <!--                        style="-->
                      <!--                          font-size: 25px;-->
                      <!--                          border-bottom: 1px solid #000;-->
                      <!--                          padding-bottom: 2px;-->
                      <!--                        "-->
                      <!--                      >-->
                      <!--                        {{ response.feeTraditionalMortgageCredit | currency }}-->
                      <!--                      </p>-->
                      <p>
                        ¡Vamos a hacerlo
                        <span class="font-weight-bold">FA$IL</span>! Muy pronto
                        nos pondremos en contacto contigo
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-1">
                      <v-btn @click="onClose" rounded :color="color" dark>
                        Cerrar
                      </v-btn>
                    </div>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>
        </div>
        <div v-else style="padding: 20px !important">
          <error @retry="onRetry($event)"></error>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Error from "./Error";

export default {
  name: "Simulator",
  components: {Error},
  data() {
    return {
      dialog: false,
      messageButton: "SIMULEMOS TU OPERACIÓN, AQUÍ",
      step: 1,
      message: "Simula cómo <b>FA$IL</b> puede ayudarte a comprar tu casa",
      color: "#00bfc9",
      disableAllFields: false,
      loading: false,
      isError: false,
      data: {
        propertyValue: null,
        creditTerm: 60,
        percentageInitialFee: null,
        name: null,
        email: null,
        phone: null,
        termsConditions: false,
        honeypot: "",
      },
      response: {
        customerFee: 0,
        traditionalMortgageCredit: 0,
        feeTraditionalMortgageCredit: 0,
      },
    };
  },
  methods: {
    pageOne() {
      this.step = 1;
      this.message =
        "Simula cómo <span style='font-weight: bold;'>FA$IL</span> puede ayudarte a comprar tu casa";
      this.color = "#00bfc9";
    },
    async pageTwo() {
      const isValid = await this.$refs.form1.validate();
      if (isValid) {
        this.step = 2;
        this.message =
          "¡Con <span style='font-weight: bold;'>tus datos</span> seguiremos en contacto!";
        this.color = "#ffb300";
      }
    },
    async pageThree() {
      this.color = "#02c7b1 ";
      const isValid = await this.$refs.form2.validate();
      if (isValid) {
        this.disableAllFields = true;
        this.loading = true;
        const baseUrl = "https://operaciones.esfasil.com/simulator";
        this.data.percentageInitialFee = this.data.percentageInitialFee / 100;
        try {
          const response = await this.$axios.post(baseUrl, this.data);
          this.response.customerFee = response.data.customerFee;
          this.response.feeTraditionalMortgageCredit =
            response.data.feeTraditionalMortgageCredit;
          this.response.traditionalMortgageCredit =
            response.data.traditionalMortgageCredit;
          this.step = 3;
          this.message =
            "Te presentamos el valor de la cuota con <span style='font-weight: bold;'>FA$IL</span>";
          this.color = "#f9004d";
          this.step = 3;
        } catch (e) {
          this.loading = false;
          this.disableAllFields = false;
          this.isError = true;
        }
      }
    },
    morePercentage() {
      this.data.percentageInitialFee =
        Number(this.data.percentageInitialFee) + 1;
    },
    lessPercentage() {
      this.data.percentageInitialFee =
        Number(this.data.percentageInitialFee) - 1;
    },
    moreCreditTerm() {
      this.data.creditTerm = Number(this.data.creditTerm) + 1;
    },
    lessCreditTerm() {
      this.data.creditTerm = Number(this.data.creditTerm) - 1;
    },
    onRetry() {
      this.isError = false;
      this.step = 2;
    },
    clear() {
      this.data.phone = null;
      this.data.email = null;
      this.data.name = null;
      this.data.percentageInitialFee = null;
      this.data.creditTerm = 60;
      this.data.propertyValue = null;
      this.data.termsConditions = false;
      this.data.honeypot = "";
      this.step = 1;
      this.response.traditionalMortgageCredit = 0;
      this.response.customerFee = 0;
      this.response.feeTraditionalMortgageCredit = 0;
      this.message =
        "Simula cómo <b>FA$IL</b> puede ayudarte a comprar tu casa";
      this.color = "#00bfc9";
      this.disableAllFields = false;
      this.loading = false;
      this.isError = false;
      this.$refs.form1.reset();
      this.$refs.form2.reset();
    },
    onClose() {
      this.clear();
      this.dialog = false;
    },
  },
};
</script>
<style>
.buttonText {
  font-size: 15px !important;
}

.v-stepper__step {
  padding: 0px 24px !important;
}

.v-stepper__step__step {
  height: 50px !important;
  width: 50px !important;
  font-size: 1.5rem !important;
  font-weight: bold;
}

.v-stepper__content {
  padding: 20px 10px !important;
}

.v-stepper__step--active {
  height: auto !important;
  width: auto !important;
}

.v-application--is-ltr .v-stepper__step__step {
  margin-right: 0px;
}

.v-stepper__header {
  height: auto !important;
}

.question,
.fee {
  font-size: 16px;
}

.mini-fee {
  font-size: 13px;
}

.v-label {
  margin-bottom: 0px !important;
}

.v-progress-circular {
  margin: 1rem;
}

#app input {
  border-radius: 0px !important;
  border: none !important;
  padding-left: 0px !important;
}

#app button {
  display: inline-flex !important;
}

#app .col-12 {
  padding-right: 15px !important;
  padding-left: 15px !important;
  padding-top: 12px !important;
  padding-bottom: 0px !important;
}

.v-btn--fab:hover {
  background: none !important;
}

.v-btn--fab:focus {
  background: none !important;
}

.v-btn--rounded {
  border-radius: 28px !important;
}

.v-btn--round {
  border-radius: 50% !important;
  border: 1px solid rgb(244, 118, 0) !important;
}

.v-btn--icon.v-size--small {
  padding: 0px !important;
  border: none !important;
}

.v-btn--icon.v-size--small:hover {
  background: none !important;
}

.v-btn--icon.v-size--small:focus {
  background: none !important;
}

.v-stepper__wrapper {
  overflow: visible;
}
</style>
